const { formatText } = require('core/i18n').i18n;
const { getSplittedNumber } = require('utilities/currencyHelper');

const getTinText = (conditions, isNewMortgagesHeader) => {
    const interestType = conditions.get('tipoInteres', '') || '';
    const currentInterestNumber = conditions.get('interes', 0) || 0;
    const interestTransform = getSplittedNumber(currentInterestNumber);
    const interest = `${interestTransform.whole}${interestTransform.decimalMark}${interestTransform.decimals}`;
    const currentDiferencialNumber = conditions.get('diferencial', 0) || 0;
    const differentialTransform = getSplittedNumber(currentDiferencialNumber);
    const differential = `${differentialTransform.whole}${differentialTransform.decimalMark}${differentialTransform.decimals}`;

    switch (interestType) {
        case '01':
            return `${interest}%`;
        case '02':
            return isNewMortgagesHeader
                ? `${interest}% ${formatText('mortgageRequestPanel-subtitleVariableMortgageText')} + ${differential}% ${formatText('mortgageRequestPanel-subtitleTin2')}`
                : `${formatText('mortgageRequestPanel-subtitleTin3')} + ${differential}%`;
        case '03':
            return `${interest}% ${formatText('mortgageRequestPanel-subtitleTin1', ['10'])} + ${differential}% ${formatText('mortgageRequestPanel-subtitleTin2')}`;

        default:
            return '';
    }
}

module.exports = {
    getTinText
}
